module.exports = __webpack_public_path__ + "img/gameListBanner.04697c70.png";